import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Error } from 'mage-components';
import { translator } from 'mage-i18n';

const styles = {
  flex: '1 0 auto',
};

const ServerError = ({ t }) => {
  return (
    <div style={styles}>
      <Error
        template="internalServerError"
        hasBackButton={false}
        hasReloadButton
        errorProps={{
          title: t('products-fe.components.app_error.title'),
          description: t('products-fe.components.app_error.message'),
        }}
      />
    </div>
  );
};

ServerError.propTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(state => ({
  t: translator(state),
}))(ServerError);
